import { ActivityIndicator, SkeletonItem, Text } from '@capsicum/common-web';
import styled from 'styled-components';

export const CARD_HEIGHT = 96;
export const HEADER_HEIGHT = 51;
export const LARGE_CARD_HEIGHT = 120;
export const LOADING_INDICATOR_HEIGHT = 100;

export const ListContainer = styled.div`
	min-height: 200px;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	flex-direction: column;
`;

export const HeaderListItem = styled.div`
	flex-direction: row;
	justify-content: space-between;
	display: flex;
	padding: 0 ${({ theme }) => theme.spacings.small};
`;

export const TransactionListItem = styled.div`
	padding: 0 ${({ theme }) => theme.spacings.small};
`;

export const LoadingIndicatorListItem = styled.div`
	display: flex;
	box-sizing: border-box;
	padding-bottom: ${({ theme }) => theme.spacings.medium};
`;

export const LoadingIndicator = styled(ActivityIndicator)`
	margin: auto auto 0 auto;
`;

export const TextStyled = styled.span`
	${({ theme }) => theme.fonts.text.text5};
	color: ${({ theme }) => theme.colors.text.main.enabled};
	text-align: left;
	height: 18px;
`;

export const SubTitle = styled.div`
	margin: ${({ theme }) => theme.spacings.small} 0 ${({ theme }) => theme.spacings.small};
`;

export const NoDataContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	padding: ${({ theme }) => `${theme.spacings.xxxlarge} ${theme.spacings.xxlarge} 0 ${theme.spacings.xxlarge}`};
`;

export const NoDataTitle = styled(Text)`
	margin-bottom: ${({ theme }) => theme.spacings.small};
`;

export const SkeletonList = styled.div`
	padding: ${({ theme }) => `0 ${theme.spacings.small}`};
	overflow: hidden;
	flex: 1;
`;

export const SkeletonHeaderRow = styled(SkeletonItem)`
	height: calc(${HEADER_HEIGHT}px - ${({ theme }) => `${theme.spacings.xxsmall}`} * 2);
	margin: ${({ theme }) => `${theme.spacings.xxsmall}`} 0;
`;

export const SkeletonCardRow = styled(SkeletonItem)`
	height: calc(${CARD_HEIGHT}px - ${({ theme }) => `${theme.spacings.small}`});
	margin-bottom: ${({ theme }) => `${theme.spacings.small}`};
`;
